import { UserRole } from "tm-shared/types";

import { isManagerRole } from "@/utils/business/isManagerRole";

export interface RouteEditorCapabilities {
    /** True if user can change/assign the agent on the route (SV, SVM). False for KAM. */
    canEditAgent: boolean;
    /** True if user can move schedules to another route. */
    canMoveSchedules: boolean;
    /** True if schedule deletion for this user is restricted when a territory plan is approved. */
    isDeleteRestrictedByPlan: boolean;
    /** True if user only operates on their own self-route (e.g. KAM). */
    isSelfRouteOnly: boolean;
}

export const getRouteEditorCapabilities = (
    role: UserRole,
): RouteEditorCapabilities => {
    const isManager = isManagerRole(role);
    const isKam = role === UserRole.Kam;

    return {
        canEditAgent: isManager && !isKam,
        canMoveSchedules: isManager,
        isDeleteRestrictedByPlan: isManager,
        isSelfRouteOnly: isKam,
    };
};
